import React, { useEffect, useState } from 'react';
import './Agroecology.css';
import logoEng from '../purayida-krishi-logo-eng.png';
import { apiGet } from '../api';

const Agroecology = () => {
  const [bgImage, setBgImage] = useState('/agrobg.jpg');
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        const data = await apiGet('/api/settings');
        if (!ignore && data?.agroecologyBackgroundUrl) {
          setBgImage(data.agroecologyBackgroundUrl);
        }
      } catch (_) {
        // Use default background if API fails
      }
    })();
    return () => { ignore = true; };
  }, []);
  
  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        setLoading(true);
        // Fetch only non-ad English posts and take 3 most recent
        const resp = await apiGet('/api/posts', { locale: 'en', isAd: 'false', limit: '6' });
        const arr = Array.isArray(resp?.items) ? resp.items : [];
        if (!ignore) {
          const mapped = arr.map((p) => ({
            id: p.id,
            title: p.title,
            excerpt: p.excerpt || '',
            date: p.date,
            category: p.categoryLabel || (p.category && (p.category.name || p.category.slug)) || 'post',
            image: p.imageUrl || undefined,
            type: p.isAd ? 'ad' : 'post',
            adText: p.adText || undefined,
            ctaText: p.ctaText || undefined,
            slug: p.slug || undefined,
          }));
          // Keep only posts (exclude ads) and ensure exactly 3 items
          const onlyPosts = mapped.filter((m) => m.type === 'post' && m.title);
          setPosts(onlyPosts.slice(0, 3));
        }
      } catch (_) {
        // ignore
      } finally {
        setLoading(false);
      }
    })();
    return () => { ignore = true; };
  }, []);
  
  return (
    <section id="agroecology" className="section agro" style={{'--agro-bg-image': `url(${bgImage})`}}>
      {/* Top left corner logo */}
      <div className="agro-corner-logo">
        <img src="/purayida-krishi-logo--white.png" alt="Purayidakrishi" className="corner-logo" />
      </div>

      <div className="container">
        <div className="agro-title">
          <img src={logoEng} alt="Purayidakrishi" className="agro-logo" />
        </div>

        {/* Row of 3 circles with text 'benifits' */}
        <div className="agro-circles">
          <span className="agro-circle"><span className="agro-circle-text">Agroecology Blog</span></span>
          <span className="agro-circle"><span className="agro-circle-text">Traditional Farming practices</span></span>
          <span className="agro-circle"><span className="agro-circle-text">Services</span></span>
        </div>

        {/* Row of 3 boxes with text 'practce' */}
        <div className="agro-grid">
          {posts.map((post) => (
            <div key={post.id} className="agro-box card">
              <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', padding: '0.75rem' }}>
                <div style={{ position: 'relative', width: '100%', paddingBottom: '56%', overflow: 'hidden', borderRadius: 12 }}>
                  <img
                    src={post.image}
                    alt={post.title}
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={(e) => { e.target.src = `https://via.placeholder.com/400x250/2d5016/ffffff?text=${encodeURIComponent(post.category)}`; }}
                  />
                  <div style={{ position: 'absolute', top: 8, left: 8, background: '#2d5016', color: '#fff', padding: '2px 8px', borderRadius: 8, fontSize: 12 }}>
                    {post.category}
                  </div>
                </div>
                <div style={{ marginTop: '0.5rem', display: 'flex', flexDirection: 'column', gap: 6 }}>
                  <h3 style={{ fontSize: '1rem', lineHeight: 1.2, margin: 0, color: '#2d5016' }}>{post.title}</h3>
                  <p style={{ fontSize: '0.85rem', color: '#374151', margin: 0 }}>{post.excerpt}</p>
                  <button
                    style={{ alignSelf: 'flex-start', display: 'inline-flex', alignItems: 'center', gap: 6, background: '#2d5016', color: '#fff', border: 'none', padding: '6px 10px', borderRadius: 8, cursor: 'pointer' }}
                    onClick={() => {
                      if (post.type === 'post' && post.slug) {
                        window.scrollTo(0, 0);
                        window.location.hash = `#/blog/en/${post.slug}`;
                      }
                    }}
                  >
                    Read More
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" /></svg>
                  </button>
                </div>
              </div>
            </div>
          ))}
          {posts.length === 0 && !loading && (
            <div className="agro-box card" style={{ alignItems: 'center', justifyContent: 'center' }}>No recent posts.</div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Agroecology;

